import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CHECK_IN,
  GET_DETAILS_BY_MOBILE_NUMBER,
  GET_LEAD_BY_BDM_API,
  GET_TIMELINE,
  GET_CHATMESSAGE,
  PAGE_SECTIONS,
} from "../../constants";
import Loader from "../reusable Component/Loader";
import axios from "axios";
import {
  Box,
  Button,
  Chip,
  Collapse,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  alpha,
  Dialog,
  DialogTitle,
  DialogContent,
  Snackbar,
  Alert,
  DialogActions,
  TextField,
} from "@mui/material";
import FilterPanel from "./FilterPanel";
import leadFormStyles from "../Leads Page/leadFormStyles.module.css";
import LongTextComponent from "../Leads Page/LongTextComponent";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import TimelineIcon from "@mui/icons-material/Timeline";
import ChatIcon from "@mui/icons-material/Chat";
import TimelineDialog from "../reusable Component/TimelineDialog";
import ChatDialog from "../reusable Component/ChatDialog";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import OnCallFormComponent from "./OnCallForm";
import CloseIcon from "@mui/icons-material/Close";
import MeetingFormComponent from "./meetingForm";
import SiteVisitFormComponent from "./siteVisitForm";
import EstimationFormComponent from "./estimationForm";
import dayjs from "dayjs";
import { useContext } from 'react';
import { ButtonVisibilityContext } from '../../Context/ButtonVisibilityContext';

import { Activity, MessageSquareText } from "lucide-react";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const BdmMobileLeadlist = ({}) => {
  const navigate = useNavigate();

  const [row, setRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(0); // Zero-based index
  const [pageSize, setPageSize] = useState(20); // Rows per page
  const [totalRows, setTotalRows] = useState(0); // Total rows count
  const [totalPages, setTotalPages] = useState(0); // Total rows count
  const [totalCount, setTotalCount] = useState(0);
  const [expandedRows, setExpandedRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [runEffect, setRunEffect] = useState(false);

  const [hotStat, setHotStat] = useState(0);
  const [warmStat, setWarmStat] = useState(0);
  const [coldStat, setColdStat] = useState(0);
  const [pendingStat, setPendingStat] = useState(0);
  const [closedStat, setClosedStat] = useState(0);

  const [filters, setFilters] = useState({
    InquiryType: "",
    Project: "",
    region: "",
    category: "",
    subcategory: "",
    campaignName: "",
    agentName: "",
    search: "",
    page: 0, // Zero-based index
    pageSize: 20, // Default page size
    last_action_date: "",
    followUpDate: "",
  });

  // useEffect(() => {
  //   fetchLeadRowData(currentPage, pageSize, filters);
  // }, [currentPage, pageSize]);

  const fetchLeadRowData = async (filters) => {
    const empId = localStorage.getItem("username");

    const {
      page,
      pageSize,
      InquiryType,
      Project,
      region,
      category,
      subcategory,
      campaignName,
      agentName,
      search,
      last_action_date,
      followUpDate,
    } = filters;

    setLoading(true);
    try {
      const response = await axios.get(
        `${GET_LEAD_BY_BDM_API}/${empId}?page=${
          page + 1
        }&limit=${pageSize}&InquiryType=${InquiryType}&Project=${Project}&region=${region}&category=${category}&subcategory=${subcategory}&campaignName=${campaignName}&agentName=${agentName}&search=${
          search === undefined ? "" : search
        }&updatedDate=${
          last_action_date === null ? "" : last_action_date
        }&followUpDate=${followUpDate === null ? "" : followUpDate}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      const { leads, totalCount, totalPages, categoryStats } = response.data;

      const finalLeads = Array.isArray(leads) ? leads : [];
      const finalStats = categoryStats || {};

    
      setRow(finalLeads);
      setTotalRows(totalCount || 0);
      setTotalPages(totalPages || 0); // Save total pages to state
      setHotStat(finalStats.hot || 0);
      setWarmStat(finalStats.warm || 0);
      setColdStat(finalStats.cold || 0);
      setPendingStat(finalStats.pending || 0);
      setClosedStat(finalStats.closed || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLoading(false);
    }
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  // const handleChangePage = (event, newPage) => {
  //   setCurrentPage(newPage); // Convert MUI's 0-based to 1-based page number
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setPageSize(parseInt(event.target.value, 10));
  //   setCurrentPage(0); // Reset to page 1 on page size change
  // };

  const handleApplyFilters = (newFilters) => {
    fetchLeadRowData(newFilters); // Adjust page and size as needed
  };

  const [showFilters, setShowFilters] = useState(false); // State to toggle the filter panel

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "hot":
        return "error"; // React blue
      case "warm":
        return "warning"; // JavaScript yellow
      case "cold":
        return "info"; // UI dark blue
      default:
        return "default"; // Default gray
    }
  };

  const [openTimeline, setopenTimeline] = useState(false);
  const [timelineLogs, setTimelineLogs] = useState([]);
  const [custData, setCustData] = useState([]);
  const {setShowButton, showButton} = useContext(ButtonVisibilityContext);

  const handletimelineClick = (row) => {
    setopenTimeline(true);
    setCustData(row);
    axios
      .get(`${GET_TIMELINE}/${row.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { leadLogs } = response.data;
        setTimelineLogs(leadLogs);
      })
      .catch((error) => {});
  };

  // customer chat states
  const [openChatMessage, setopenChatMessages] = useState(false);
  const [chatMessageData, setchatMessageData] = useState([]);
  const [custChats, setCustChats] = useState([]);
  const [startPolling,setStartPolling] = useState(false);
  const [messageLoading,setMessageLoading] = useState(false);

  const handleChatClick = (row)=>{
   setopenChatMessages(true);
   localStorage.setItem('userMobileNo', JSON.stringify(row.MobileNo));
   setShowButton(false); 
   setCustChats(row);
   setMessageLoading(true)
   chatMessageApiCalled(row);
   setStartPolling(true);
  }

  const chatMessageApiCalled = (row)=>{
     axios
      .get(`${GET_CHATMESSAGE}/${row.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const result = response.data;
        console.log("result on click:",result)
        setchatMessageData(result.data.chatMessages);
        setMessageLoading(false)
      })
      .catch((error) => {
        console.log("error on getting messages",error);
        setMessageLoading(false);
      });
  }

  useEffect(()=>{
  if(!startPolling) return;
  if(!custChats?.id) return;
  const interval =setInterval(()=>{
       chatMessageApiCalled(custChats);
  },5000);
    return () => clearInterval(interval);
  },[startPolling, custChats])

  // const handleIconClick = (row) => {
  //   axios
  //     .get(`${GET_DETAILS_BY_MOBILE_NUMBER}/${row.MobileNo}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //       },
  //     })
  //     .then((response) => {
  //       const { lead } = response.data;

  //       // Pass the data to handlingRowData
  //       handlingRowData1(lead);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching lead details:", error);
  //     });
  // };

  const handlingRowData1 = (data) => {
    if (!data || data.length === 0) {
      console.warn("No lead data available to transform.");
      return;
    }
    const transformedRows = [data].map((rd, index) => ({
      id: index + 1,
      SNo: index + 1,
      leadId: rd.id,
      CustomerName: rd.CustomerName?.trim() || "-",
      MobileNo: rd.MobileNo || "-",
      AlternateMobileNo: rd.AlternateMobileNo || "-",
      state_name: rd.state_name || "-",
      source_of_lead_generated: rd.Campaign?.CampaignName || "-",
      category: rd.category || "-",
      AgentId: rd.AgentId,
      BDMId: rd.BDMId,
      CustomerMailId: rd.CustomerMailId || "-",
      InquiryType: rd.InquiryType || "-",
      Project: rd.Project || "-",
      Superviser: rd.Superviser,
      SuperviserID: rd.SuperviserID,
      WhatsappNo: rd.WhatsappNo || "-",
      agent_remark: rd.agent_remark || "-",
      close_month: rd.close_month || "-",
      follow_up_date: rd.follow_up_date ? formatDate(rd.follow_up_date) : "-",
      lead_owner: rd.BDM?.EmployeeName || "-",
      lead_transfer_date: rd.lead_transfer_date
        ? formatDate(rd.lead_transfer_date)
        : "-",
      location: rd.location || "-",
      site_location_address: rd.site_location_address || "-",
      region_name: rd.region_name || "-",
      sub_category: rd.sub_category || "-",
      Agent: rd.Agent,
      AgentName: rd.Agent?.EmployeeName || "-",
      BDM: rd.BDM,
      pincode: rd.pincode || "-",
      call_status: rd.call_status,
      call_type: rd.call_type,
      createdDate: rd.createdAt ? formatDate(rd.createdAt) : "-",
      bdm_remark: rd.bdm_remark || "-",
      lead_calling_date: "-",
      bdm_calling_date: "-",
      updatedAt: rd.updatedAt ? formatDate(rd.updatedAt) : "-",
      last_action: rd.last_action || "-",
    }));

    // Store transformed data in localStorage
    localStorage.setItem("leadDetails", JSON.stringify(transformedRows[0]));

    setTimeout(() => navigate("/mobilebdmpage"), 100);
  };

  const handleRowClick = (index) => {
    const newExpandedRows = expandedRows.includes(index)
      ? expandedRows.filter((i) => i !== index)
      : [...expandedRows, index];
    setExpandedRows(newExpandedRows);
  };

  const rowExpansionTemplate = (data) => (
    <>
      <Grid container spacing={1} p={1}>
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Region:
          </Typography>
          <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
            {data.region_name}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Branch:
          </Typography>
          <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
            {data.branchName}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Lead Owner:
          </Typography>
          <Typography variant="body2">{data.lead_owner || "-"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Location:
          </Typography>
          <Typography variant="body2">{data.location || "-"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            State:
          </Typography>
          <Typography variant="body2">{data.state_name || "-"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Mail ID:
          </Typography>
          <Typography variant="body2" sx={{ textDecoration: "none" }}>
            {data.CustomerMailId || "-"}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Date of First Calling:
          </Typography>
          <Typography variant="body2">
            {data.createdAt === null ? "-" : formatDate(data.createdAt)}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Follow-up Date:
          </Typography>
          <Typography variant="body2">
            {data.follow_up_date === null
              ? "-"
              : formatDate(data.follow_up_date)}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Closure Month:
          </Typography>
          <Typography variant="body2">
            {row?.close_month ? dayjs(row.close_month).format("MMM-YYYY") : "-"}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Date of Lead Transfer:
          </Typography>
          <Typography variant="body2">
            {data.lead_transfer_date === null
              ? "-"
              : formatDate(data.lead_transfer_date)}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Date of BDM Calling:
          </Typography>
          <Typography variant="body2">
            {data.bdm_calling_date || "-"}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Campaign Name:
          </Typography>
          <Typography variant="body2">
            {data.Campaign?.CampaignName || "-"}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            CSE Name:
          </Typography>
          <Typography variant="body2">{data.AgentName || "-"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Project:
          </Typography>
          <Typography variant="body2">{data.Project || "-"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Alternate Mobile Number:
          </Typography>
          <Typography variant="body2">
            {data.AlternateMobileNo || "-"}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Whatsapp Number:
          </Typography>
          <Typography variant="body2">{data.WhatsappNo || "-"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Category:
          </Typography>
          <Typography variant="body2">
            <Chip
              label={data.category}
              color={getColorForTag(data.category)}
              size="small"
              sx={{ textTransform: "capitalize" }}
            />
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Sub-Category:
          </Typography>
          <Typography variant="body2">{data.sub_category || "-"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            Agent Remark:
          </Typography>
          <Typography variant="body2" sx={{ textAlign: "end" }}>
            <LongTextComponent
              text={data.agent_remark == null ? "-" : data.agent_remark}
              maxLength={50}
            />
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            className={`${leadFormStyles.label_margin}`}
          >
            BDM Remark:
          </Typography>
          <Typography variant="body2" sx={{ textAlign: "end" }}>
            <LongTextComponent
              text={data.agent_remark == null ? "-" : data.agent_remark}
              maxLength={50}
            />
          </Typography>
        </Grid>
      </Grid>
    </>
  );

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [travelDetailsId, setTravelDetailsId] = useState("");

  const handleCloseDialog = () => {
    setOpenConfirmDialog(false);
  };

  // Handle the confirmation action
  const confirmCheckIn = async () => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        // Create the payload with the task details and location data
        const payload = {
          bdmId: localStorage.getItem("username"),
          leadDetailId: leadDetails.id || null,
          attendanceId:
            JSON.parse(localStorage.getItem("userData")).todayAttendance
              ?.attendanceId ||
            JSON.parse(localStorage.getItem("attendance")).attendanceId,
          action: typeOfForm,
          bdmLeadActionId: null,
          latitude: latitude,
          longitude: longitude,
        };

        setOpenConfirmDialog(false); // Close the confirmation dialog
        setLoading(true);

        try {
          const response = await axios.post(`${CHECK_IN}`, payload);
          const { message, travelDetail } = response.data;
          setOpenFormDialog(true);
          // setTravelDetailsId(travelDetail,)
          setOpenSnackbar(true);
          setSeverity("success");
          setMessage(message);
        } catch (error) {
          console.error("Error submitting actions:", error);
          setOpenSnackbar(true);
          setSeverity("error");
          setMessage(error.response.data.message);
          setOpenConfirmDialog(false); // Close the confirmation dialog
        } finally {
          setLoading(false); // Reset loading state
        }
      },
      (error) => {
        // Handle error when geolocation fails
        console.error("Error fetching location:", error);
        // Set a fallback location or show an error message
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };

  const [openFormDialog, setOpenFormDialog] = useState(false);

  const [typeOfForm, setTypeOfForm] = useState("");

  const [leadDetails, setLeadDetails] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleIconClick = (event, row) => {
    event.stopPropagation(); // Prevents row click triggering
    setLeadDetails(row);
    localStorage.setItem("leadDetails", JSON.stringify(row));

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (option) => {
    const value = option.currentTarget.textContent;
    console.log(value);

    if (value === "Estimation Generated") {
      navigate("/mobilebdmpage", { state: { action: value } });
    } else if (value === "Estimation Shared") {
      navigate("/mobilebdmpage", { state: { action: value } });
    } else if (value === "Converted") {
      navigate("/mobilebdmpage", { state: { action: value } });
    } else if (value === "Meeting") {
      setTypeOfForm(value);
      setOpenConfirmDialog(true);
    } else if (value === "Site Visit") {
      setTypeOfForm(value);
      setOpenConfirmDialog(true);
    } else {
      setTypeOfForm(value);
      setOpenFormDialog(true);
    }
    handleClose();
  };

  const handleCloseFormDialog = () => {
    setLeadDetails([]);
    setOpenFormDialog(false);
    setTypeOfForm("");
  };

  const handleCategoryFilter = (value) => {
    const newFilters = {
      InquiryType: "",
      Project: "",
      region: "",
      category: value,
      subcategory: "",
      campaignName: "",
      agentName: "",
      page: 0, // Zero-based index
      pageSize: 20, // Default page size
      last_action_date: "",
      followUpDate: "",
    };
    setFilters(newFilters);
    handleApplyFilters(newFilters);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [openTaskDialog, setOpenTaskDialog] = useState(false);
  const [siteVisitForm, setSiteVisitForm] = useState(false);
  const [estimationForm, setEstimationForm] = useState(false);

  const handleInteractionClick = (row) => {
    navigate('/customer-interaction', { state: { value: row } });
  };

  return (
    <>
      {loading && <Loader open={loading} />}

      <>
        <Box
          sx={{
            display: "flex", // Use flexbox for layout
            flexWrap: "wrap", // Allow wrapping for responsiveness
            gap: "12px", // Add space between boxes
            justifyContent: "start", // Align boxes to the start
            mb: 2,
          }}
        >
          {[
            { label: "Total Leads", value: totalRows, bgColor: "#000080" },
            { label: "Hot", value: hotStat, bgColor: "#ff0000" },
            { label: "Warm", value: warmStat, bgColor: "#FFA500" },
            { label: "Cold", value: coldStat, bgColor: "#0096FF" },
            { label: "Pending", value: pendingStat, bgColor: "#DE3163" },
            { label: "Closed", value: closedStat, bgColor: "#0BDA51" },
          ].map(({ label, value, bgColor }) => (
            <Box
              key={label}
              sx={{
                backgroundColor: bgColor,
                padding: { xs: "8px", md: "16px" }, // Smaller padding on mobile
                borderRadius: "8px", // Rounded corners
                border: "1px solid #ccc", // Light border color
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Elevated box shadow
                display: "inline-block", // Ensure it takes only as much space as needed
                minWidth: { xs: "100px", md: "140px" }, // Adjust width for smaller screens
                textAlign: "center", // Center-align text for better appearance
                cursor: "pointer",
              }}
              onClick={() => handleCategoryFilter(label.toLowerCase())}
            >
              <Typography
                sx={{
                  fontWeight: "bold", // Make the text bold
                  fontSize: { xs: "1rem", md: "1.2rem" }, // Smaller font size on mobile
                  color: "#fff", // Set a darker color for better visibility
                }}
              >
                {label}: {value}
              </Typography>
            </Box>
          ))}
        </Box>

        <div>
          <Paper>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div></div>
              <FilterPanel
                filters={filters}
                setFilters={setFilters}
                onApplyFilters={handleApplyFilters}
              />
            </div>

            <TableContainer
              sx={{
                boxShadow: 2,
                borderRadius: "8px",
                margin: "8px 0",
              }}
            >
              <Table
                sx={{
                  minWidth: 250,
                  height: "100%",
                  tableLayout: "fixed", // Ensures equal column width distribution
                }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                    <TableCell
                      align="left"
                      sx={{
                        padding: 0,
                        fontWeight: "bold",
                        width: 10,
                      }}
                    ></TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        padding: 1,
                        width: 30,
                        fontWeight: "bold",
                      }}
                    >
                      SNo
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        padding: 1,
                        fontWeight: "bold",
                      }}
                    >
                      Farmer Name
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        padding: 1,
                        fontWeight: "bold",
                      }}
                    >
                      Mobile Number
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        padding: 1,
                        fontWeight: "bold",
                        backgroundColor: "#EEF0F4",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No Data Available Yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    row.map((row, index) => (
                      <React.Fragment key={row.SNo}>
                        <TableRow sx={{ cursor: "pointer" }}>
                          {/* Expand Action */}
                          <TableCell align="left" sx={{ padding: 0 }}>
                            <button onClick={() => handleRowClick(index)}>
                              {expandedRows.includes(index) ? (
                                <ArrowDropDownIcon />
                              ) : (
                                <ArrowRightIcon />
                              )}
                            </button>
                          </TableCell>

                          {/* Other Columns */}
                          <TableCell align="center">
                            {filters.page * filters.pageSize + index + 1}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ wordBreak: "break-word" }}
                          >
                            {row.CustomerName}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ textDecoration: "none" }}
                          >
                            {row.MobileNo}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ backgroundColor: "#EEF0F4" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <>
                              {/* // chat_feature aman  */}
                                <Tooltip title="Timeline" arrow>
                                  <IconButton
                                    style={{
                                      border: "1px solid",
                                      borderRadius: "4px",
                                      padding: "2px",
                                      width: "24px",
                                      height: "24px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      marginRight: "5px",
                                      backgroundColor: "#fff",
                                    }}
                                    color="primary"
                                    onClick={() => handletimelineClick(row)}
                                  >
                                    <TimelineIcon
                                      fontSize="small"
                                      color="primary"
                                    />
                                  </IconButton>
                                </Tooltip>
                               
                                 {/* <Tooltip title="Chats" arrow>
                                 <IconButton
                                  id="demo-customized-button"
                                  aria-controls={
                                    open ? "demo-customized-menu" : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={open ? "true" : undefined}
                                  variant="contained"
                                  disableElevation
                                  onClick={(event) =>
                                    handleIconClick(event, row)
                                  }
                                  style={{
                                    border: "1px solid",
                                    borderRadius: "4px",
                                    padding: "2px",
                                    width: "24px",
                                    height: "24px",
                                    backgroundColor: "#fff",
                                    marginRight: "5px",
                                  }}
                                >
                                  <EditIcon fontSize="small" color="primary" />
                                </IconButton>
                                
                                 </Tooltip> */}
                               
                                 {/* <Tooltip title="Chats" arrow>
                                  <IconButton
                                    style={{
                                      border: "1px solid",
                                      borderRadius: "4px",
                                      padding: "2px",
                                      width: "24px",
                                      height: "24px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                     
                                      backgroundColor: "#fff",
                                    }}
                                    color="primary"
                                    onClick={() => handleChatClick(row)}
                                  >
                                   <ChatIcon
                                     fontSize="small"
                                     color="primary"
                                     />
                                  </IconButton>
                                </Tooltip> */}
                                <StyledMenu
                                  id="demo-customized-menu"
                                  MenuListProps={{
                                    "aria-labelledby": "demo-customized-button",
                                  }}
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose}
                                >
                                  {PAGE_SECTIONS.map((eq) => (
                                    <MenuItem
                                    key={eq.id ||index}
                                      onClick={(event) =>
                                        handleMenuClick(event)
                                      }
                                      value={eq.value}
                                      disableRipple
                                    >
                                      {eq.label}
                                    </MenuItem>
                                  ))}
                                </StyledMenu>

                                {/* <Tooltip title="interaction" arrow>
                                  <IconButton
                                    style={{
                                      border: "1px solid",
                                      borderRadius: "4px",
                                      padding: "2px",
                                      width: "24px",
                                      height: "24px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      marginLeft: "5px",
                                      backgroundColor: "#fff",
                                    }}
                                    color="primary"
                                    onClick={() => handleInteractionClick(row)}
                                  >
                                    <Activity />
                                  </IconButton>
                                </Tooltip> */}
                              </>
                            </Box>
                          </TableCell>
                        </TableRow>

                        {/* Collapse Row */}
                        {expandedRows.includes(index) && (
                          <TableRow>
                            <TableCell colSpan={5} sx={{ padding: 0 }}>
                              <Collapse in={expandedRows.includes(index)}>
                                <Box
                                  sx={{
                                    padding: 2,
                                    overflowX: "auto", // Add horizontal scrolling if content exceeds container width
                                  }}
                                >
                                  {rowExpansionTemplate(row)}
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalRows ?? 0} // Fallback to 0 if totalRows is undefined or null
              page={filters.page >= 0 ? filters.page : 0} // Use page from filters, fallback to 0 if invalid
              onPageChange={(event, newPage) => {
                setFilters((prevFilters) => {
                  const updatedFilters = { ...prevFilters, page: newPage };
                  fetchLeadRowData(updatedFilters); // Fetch leads with the updated page
                  return updatedFilters;
                });
              }}
              rowsPerPage={filters.pageSize > 0 ? filters.pageSize : 10} // Use pageSize from filters, fallback to 10 if invalid
              onRowsPerPageChange={(event) => {
                const newPageSize = parseInt(event.target.value, 10);
                setFilters((prevFilters) => {
                  const updatedFilters = {
                    ...prevFilters,
                    pageSize: newPageSize,
                    page: 0,
                  }; // Reset to page 0 when rows per page change
                  fetchLeadRowData(updatedFilters); // Fetch leads with the updated pageSize
                  return updatedFilters;
                });
              }}
              rowsPerPageOptions={[10, 20, 25]} // Options for rows per page
            />
          </Paper>
        </div>
      </>

      <TimelineDialog
        open={openTimeline}
        setOpen={setopenTimeline}
        timelineLogs={timelineLogs}
        custData={custData}
      ></TimelineDialog>
      <ChatDialog
      open={openChatMessage}
      loading={loading}
      setLoading={setLoading}
      setOpen={setopenChatMessages}
      chatMessageData={chatMessageData}
      custChats={custChats}
/>

      {/* Form Dialog */}
      <Dialog open={openFormDialog} onClose={handleCloseFormDialog}>
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
          }}
        >
          {typeOfForm}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseFormDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {(() => {
            if (typeOfForm === "On-Call Discussion") {
              return (
                <>
                  <OnCallFormComponent
                    roleType={"BDM"}
                    setSeverity={setSeverity}
                    setMessage={setMessage}
                    setOpenSnackbar={setOpenSnackbar}
                    setRunEffect={setRunEffect}
                    leadId={JSON.parse(localStorage.getItem("leadDetails")).id}
                    handleCloseFormDialog={handleCloseFormDialog}
                  ></OnCallFormComponent>
                </>
              );
            } else if (typeOfForm === "Meeting") {
              return (
                <>
                  <MeetingFormComponent
                    setShowMeetingForm={setShowMeetingForm}
                    leadDetailsId={
                      JSON.parse(localStorage.getItem("leadDetails")).id
                    }
                    setSeverity={setSeverity}
                    setMessage={setMessage}
                    setOpenSnackbar={setOpenSnackbar}
                    setRunEffect={setRunEffect}
                    setOpenTaskDialog={setOpenTaskDialog}
                    setPlaceOfSubmit={"LeadPage"}
                    handleCloseFormDialog={handleCloseFormDialog}
                  />
                </>
              );
            } else if (typeOfForm === "Site Visit") {
              return (
                <>
                  <SiteVisitFormComponent
                    setSiteVisitForm={setSiteVisitForm}
                    leadDetailsId={
                      JSON.parse(localStorage.getItem("leadDetails")).id
                    }
                    setSeverity={setSeverity}
                    setMessage={setMessage}
                    setOpenSnackbar={setOpenSnackbar}
                    setRunEffect={setRunEffect}
                    setOpenTaskDialog={setOpenTaskDialog}
                    placeOfSubmit={""}
                    handleCloseFormDialog={handleCloseFormDialog}
                  />
                </>
              );
            } else if (typeOfForm === "Estimation Request") {
              return (
                <>
                  <EstimationFormComponent
                    setEstimationForm={setEstimationForm}
                    setSeverity={setSeverity}
                    setMessage={setMessage}
                    setOpenSnackbar={setOpenSnackbar}
                    setRunEffect={setRunEffect}
                    leadDetailsId={
                      JSON.parse(localStorage.getItem("leadDetails")).id
                    }
                    handleCloseFormDialog={handleCloseFormDialog}
                  />
                </>
              );
            }
          })()}
        </DialogContent>
      </Dialog>

      

      {/* Confirmation Dialog */}
      <Dialog open={openConfirmDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Check In</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to check in for the task ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={confirmCheckIn} color="primary" variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default BdmMobileLeadlist;
